import checkForInfinityOrNaN from 'helpers/presentation/checkForInfinityOrNaN'
import accuracyMap from 'helpers/presentation/accuracyMap'
import { CONVENTIONAL } from 'helpers/globals'

/**
 * Converts a camera's tilt to a user-friendly display value, based on vertical angle
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Number} args.tilt
 * @param {Number} args.horizontalAngleOfView
 * @param {Number} args.verticalAngleOfView
 * @param {Number} args.fovMode
 * @param {Boolean} args.raw
 * @return {String/Number} Friendly tilt value
 */

export default function computeFriendlyTilt({ tilt, horizontalAngleOfView, verticalAngleOfView, fovMode, raw }) {
  const angle = fovMode === CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView
  const convertedTilt = tilt - angle / 2.0

  if (raw) return convertedTilt

  return checkForInfinityOrNaN(convertedTilt) ? '0' : convertedTilt.toFixed(accuracyMap().get('tilt'))
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/computeFriendlyTilt.js